import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="pt-32">
        {/* Hero */}
        <section className="bg-gradient-to-b from-gray-50 to-white py-16">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <h1 className="font-serif text-5xl md:text-6xl font-light text-gray-900 mb-6">
              About NovaRadiance Distribution
            </h1>
            <p className="text-xl text-gray-700 max-w-3xl leading-relaxed">
              Bridging the gap between China's leading manufacturers and the American market with seamless service, expert guidance, and no language barriers.
            </p>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
              {/* Image */}
              <div className="relative h-[600px] rounded-lg overflow-hidden">
                <img 
                  src="https://static.wixstatic.com/media/b85534_cc3439f64ac14034ade1540063ba0c50~mv2.jpg"
                  alt="Red Light Therapy Room"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content */}
              <div>
                <h2 className="font-serif text-4xl md:text-5xl font-light text-gray-900 mb-8">
                  Our Vision and Purpose
                </h2>

                <div className="space-y-6">
                  <div>
                    <h3 className="font-serif text-2xl font-medium text-gray-900 mb-3">Who We Are</h3>
                    <p className="text-gray-700 leading-relaxed">
                      At NovaRadiance Distribution L.L.C., we are dedicated to enhancing quality of life through advanced light therapy solutions. We bridge the gap between China's leading manufacturers and the American market, providing you with the advantage of working within your time zone with no language barriers.
                    </p>
                  </div>

                  <div>
                    <h3 className="font-serif text-2xl font-medium text-gray-900 mb-3">What We Offer</h3>
                    <p className="text-gray-700 leading-relaxed">
                      Specializing in infrared light beds, red light masks, and panels, we focus on educating customers regarding the profound advantages of infrared technology over traditional options. Our products are manufactured in ISO-certified facilities with rigorous quality control, ensuring the highest standards of safety and effectiveness.
                    </p>
                  </div>

                  <div>
                    <h3 className="font-serif text-2xl font-medium text-gray-900 mb-3">Why Choose Us</h3>
                    <p className="text-gray-700 leading-relaxed">
                      As your US-based partner, we eliminate the complexities of international sourcing. Enjoy seamless communication, reliable support, and expert guidance—all in your time zone. We provide comprehensive support including installation training, marketing materials, and long-term buyback agreements, ensuring you're valued and well-informed throughout your journey.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Values */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20">
              <div className="bg-gray-50 rounded-lg p-8">
                <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <h3 className="font-serif text-xl font-medium text-gray-900 mb-3">Quality Assurance</h3>
                <p className="text-gray-700 leading-relaxed">
                  All products manufactured in ISO 13485 certified facilities with comprehensive testing and quality control protocols.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-8">
                <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-customer-service-2-line text-2xl text-white"></i>
                </div>
                <h3 className="font-serif text-xl font-medium text-gray-900 mb-3">US-Based Support</h3>
                <p className="text-gray-700 leading-relaxed">
                  Work directly with our American team in your time zone. No language barriers, no international complications.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-8">
                <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-lightbulb-line text-2xl text-white"></i>
                </div>
                <h3 className="font-serif text-xl font-medium text-gray-900 mb-3">Expert Guidance</h3>
                <p className="text-gray-700 leading-relaxed">
                  Comprehensive education on infrared vs. red light therapy, helping you make informed decisions for your needs.
                </p>
              </div>
            </div>

            {/* Manufacturing Excellence */}
            <div className="bg-gray-900 rounded-lg p-12 text-white mb-20">
              <h2 className="font-serif text-4xl font-light mb-8 text-center">
                Manufacturing Excellence
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                <div className="text-center">
                  <div className="text-4xl font-light text-teal-400 mb-2">10,000</div>
                  <div className="text-sm text-gray-300">Square Meter Factory</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-light text-teal-400 mb-2">ISO 13485</div>
                  <div className="text-sm text-gray-300">Certified Facility</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-light text-teal-400 mb-2">70+</div>
                  <div className="text-sm text-gray-300">Quality Tests</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-light text-teal-400 mb-2">3-Year</div>
                  <div className="text-sm text-gray-300">Warranty Coverage</div>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="text-center">
              <h2 className="font-serif text-4xl md:text-5xl font-light text-gray-900 mb-6">
                Ready to Partner With Us?
              </h2>
              <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto leading-relaxed">
                Experience the difference of working with a trusted US distributor. Let's discuss how our therapy solutions can benefit your business or wellness goals.
              </p>
              <Link 
                to="/contact"
                className="inline-block bg-teal-600 text-white px-8 py-3 rounded-md text-sm font-medium hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                Contact Us Today
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default About;
